<!-- 清单 -->
<template>
    <div class='inventory'>
      <el-form :model="form" :rules="form.rules" ref="form" :disabled="readonly">
          <div v-if="parentCodeType == $root.gc_category">
            <div>
              <div v-if="operationEnable">
                <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData1"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
              </div>
              <el-table :max-height="maxHeight" key="tableData1" border :data="form.tableData1" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                  <el-table-column label="序号" type="index" fixed="left" width="50px">
                      <template slot-scope="scope">
                          <el-form-item>
                              <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                          </el-form-item>
                      </template>
                  </el-table-column>
                  <el-table-column label="报价类型" width="140px" v-if="false">
                      <template slot-scope="scope">
                          <el-select v-model="scope.row.quotationType"
                                     size="mini"
                                     class="minWidth">
                              <el-option :value="1" label="计入合价"></el-option>
                              <el-option :value="2" label="不计入合价"></el-option>
                          </el-select>
                      </template>
                  </el-table-column>
                  <el-table-column label="分部分项名称" width="140px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.subitemName'" :rules='form.rules.subitemName' :class="{input_box:true,error_box:!scope.row.subitemName}">
                        <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.subitemName" v-if="scope.row.dealListStatus != 1"></el-input>
                        <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.subitemName" v-else disabled></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="工程项名称" width="140px">
                    <!-- <template slot-scope="scope">
                        <div :class="{input_box:true,error_box:!scope.row.matterName}">
                            <input type="text" class="input_block" v-model="scope.row.matterName">
                        </div>
                    </template> -->
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.matterName'" :rules='form.rules.matterName' :class="{input_box:true,error_box:!scope.row.matterName}">
                        <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName" v-if="scope.row.dealListStatus != 1"></el-input>
                        <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName" v-else disabled></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="工作/工艺内容描述/规格型号参数" width="240px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired' :class="{input_box:true,error_box:!scope.row.matterRequired}">
                        <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired" v-if="scope.row.dealListStatus != 1"></el-input>
                        <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired" v-else disabled></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="投标品牌" width="140px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.brandName'" :rules='form.rules.brandName' :class="{input_box:true,error_box:!scope.row.brandName}">
                        <el-input size="mini" v-model="scope.row.brandName" v-if="scope.row.dealListStatus != 1"></el-input>
                        <el-input size="mini" v-model="scope.row.brandName" v-else disabled></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="单位" width="140px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.unitName'" :rules='form.rules.unitName' :class="{input_box:true,error_box:!scope.row.unitName}">
                        <el-input size="mini" v-model="scope.row.unitName" v-if="scope.row.dealListStatus != 1"></el-input>
                        <el-input size="mini" v-model="scope.row.unitName" v-else disabled></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" width="140px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.quantities'" :rules='form.rules.quantities' :class="{input_box:true,error_box:!scope.row.quantities}">
                        <el-input size="mini" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"
                        v-if="scope.row.dealListStatus != 1"></el-input>
                        <el-input size="mini" v-model="scope.row.quantities" v-else disabled></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
                  <el-table-column label="不含税综合单价（元）" width="140px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'>
                        {{scope.row.unitAmountExclTax}}
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="税率（%）" width="140px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio' :class="{input_box:true,error_box:!scope.row.taxRatio}">
                        <el-select size="mini" :disabled="scope.row.dealListStatus == 1" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                          <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                        </el-select>
                        <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"
                        v-if="scope.row.dealListStatus != 1"></el-input>
                        <el-input size="mini" v-model="scope.row.taxRatio" v-else disabled></el-input> -->
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="含税综合单价（元）" width="140px">
                      <template slot-scope="scope">
						      <el-form-item :prop="'tableData1.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax' :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        	<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"
                          v-if="scope.row.dealListStatus != 1"></el-input>
                          <el-input size="mini" v-model="scope.row.unitAmountWithTax" v-else disabled></el-input>
						      </el-form-item>
                      </template>
                  </el-table-column>
                  <el-table-column label="税金（元）" width="140px">
                    <template slot-scope="scope">
                        {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                    </template>
                  </el-table-column>
                  <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData1.' + scope.$index + '.amountExclTax'" :rules='form.rules.amountExclTax'>
                        {{Number($root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)).toFixed(2) }}
                        <!-- {{Number(scope.row.amountExclTax).toFixed(2)}} -->
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                    <template slot-scope="scope">
                        <el-form-item :prop="'tableData1.' + scope.$index + '.amountWithTax'" :rules='form.rules.amountWithTax'>
                          {{Number($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities)).toFixed(2) }}
                        <!-- {{scope.row.amountWithTax}} -->
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                      <template slot-scope="scope">
                          <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}</span>
                      </template>
                  </el-table-column>
                  <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                      <template slot-scope="scope">
                          <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}</span>
                      </template>
                  </el-table-column>
                  <el-table-column label="专业分类" width="140px">
                    <template slot-scope="scope">
                      {{categoryName}}
                    </template>
                  </el-table-column>
                  <el-table-column label="事项说明" width="80px" prop="remarks" fixed="right">
                      <template slot-scope="scope">
                          <el-form-item v-if="operationEnable">
                              <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                        v-model="scope.row.remarks"></el-input>
                          </el-form-item>
                          <span v-else>
                              {{ scope.row.remarks }}
                          </span>
                      </template>
                  </el-table-column>
                  <el-table-column label="规格尺寸" width="140px" prop="speciificationSize">
                      <template slot-scope="scope">
                          <el-form-item v-if="operationEnable">
                              <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                        v-model="scope.row.speciificationSize"></el-input>
                          </el-form-item>
                          <span v-else>
                              {{ scope.row.speciificationSize }}
                          </span>
                      </template>
                  </el-table-column>
                  <el-table-column label="状态" width="100px" fixed="right" v-if="operationEnable ">
                    <template slot-scope="scope">
                          <div v-if="scope.row.dealListStatus== 1" style="color:#67c23a;">合格</div>
                          <div v-if="scope.row.dealListStatus == 2" style="color:#f56c6c;">修改</div>
                          <div v-if="scope.row.dealListStatus == 3" style="color:#e6a23c;">已修改</div>
                          <div v-if="scope.row.dealListStatus == 4" style="color:#409eff;">新增</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="说明" width="140px" prop="dealListRemarks" fixed="right" v-if="operationEnable">
                      <template slot-scope="scope">
                          <el-input
                              type="text"
                              disabled
                              size="mini"
                              placeholder=""
                              v-model="scope.row.dealListRemarks">
                          </el-input>
                      </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" @click="del(scope.$index, 1)" v-if="scope.row.dealListStatus != 1"> 删除</el-button>
                    </template>
                  </el-table-column>

              </el-table>
            </div>
          </div>
        <div v-else-if="parentCodeType == $root.wzsb_category">
            <div v-if="operationEnable">
              <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData3"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
            </div>
            <el-table :max-height="maxHeight" key="tableData3" border :data="form.tableData3" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
              <el-table-column label="序号" type="index" fixed="left" width="100px">
                  <template slot-scope="scope">
                      <el-form-item>
                          <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                      </el-form-item>
                  </template>
              </el-table-column>
                <el-table-column label="报价类型" width="140px" v-if="false">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.quotationType"
                                   size="mini"
                                   class="minWidth">
                            <el-option :value="1" label="计入合价"></el-option>
                            <el-option :value="2" label="不计入合价"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
              <el-table-column label="招标事项" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData3.' + scope.$index + '.matterName'" :rules='form.rules.matterName' :class="{input_box:true,error_box:!scope.row.matterName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="招标需求内容描述/材质工艺等要求/规格型号" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData3.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired' :class="{input_box:true,error_box:!scope.row.matterRequired}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column label="规格尺寸" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData3.' + scope.$index + '.speciificationSize'" :rules='form.rules.speciificationSize'>
                    <el-input size="mini" v-model="scope.row.speciificationSize"></el-input>
                  </el-form-item>
                </template>
              </el-table-column> -->
              <el-table-column label="投标品牌" width="140px">
                <template slot-scope="scope">
                  <!-- :readonly="priceDisable" -->
                  <el-form-item :prop="'tableData3.' + scope.$index + '.brandName'" :rules='form.rules.brandName' :class="{input_box:true,error_box:!scope.row.brandName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''"  v-model="scope.row.brandName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData3.' + scope.$index + '.quantities'" :rules='form.rules.quantities' :class="{input_box:true,error_box:!scope.row.quantities}">
                    <el-input size="mini" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
              <el-table-column label="单位" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData3.' + scope.$index + '.unitName'" :rules='form.rules.unitName' :class="{input_box:true,error_box:!scope.row.unitName}">
                    <el-input size="mini" v-model="scope.row.unitName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="不含税单价（元）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData3.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'>
                    {{scope.row.unitAmountExclTax}}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="税率（%）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData3.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio' :class="{input_box:true,error_box:!scope.row.taxRatio}">
                    <el-select size="mini" :disabled="scope.row.dealListStatus == 1" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                      <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                    </el-select>
                    <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                  <template slot-scope="scope">
					  	<el-form-item :prop="'tableData3.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax' :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        	<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
						</el-form-item>
                  </template>
              </el-table-column>
              <el-table-column label="税金（元）" width="140px">
                <template slot-scope="scope">
                    {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                </template>
              </el-table-column>
              <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                <template slot-scope="scope">
                  {{$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)}}
                </template>
              </el-table-column>
              <el-table-column label="含税合价（元）" width="140px">
                <template slot-scope="scope">
                    {{$root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities)}}
                </template>
              </el-table-column>

              <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}</span>
                    </template>
              </el-table-column>
              <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="del(scope.$index, 3)"> 删除</el-button>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="100px" fixed="right" v-if="operationEnable">
                <template slot-scope="scope">
                  <template slot-scope="scope">
                      <div v-if="scope.row.dealListStatus == null || scope.row.dealListStatus == 1" style="color:#67c23a;">合格</div>
                      <div v-if="scope.row.dealListStatus == 2" style="color:#f56c6c;">修改</div>
                      <div v-if="scope.row.dealListStatus == 3" style="color:#e6a23c;">已修改</div>
                      <div v-if="scope.row.dealListStatus == 4" style="color:#409eff;">新增</div>
                      <!-- <el-button type="text" size="mini" >正常</el-button> -->
                  </template>
                </template>
              </el-table-column>
          </el-table>
        </div>
        <div v-else-if="parentCodeType == $root.yxtg_category">
            <div v-if="operationEnable">
              <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData4"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
            </div>
            <el-table :max-height="maxHeight" key="tableData4" border :data="form.tableData4" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
              <el-table-column label="序号" type="index" fixed="left" width="100px">
                  <template slot-scope="scope">
                      <el-form-item>
                          <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                      </el-form-item>
                  </template>
              </el-table-column>
                <el-table-column label="报价类型" width="140px" v-if="false">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.quotationType"
                                   size="mini"
                                   class="minWidth">
                            <el-option :value="1" label="计入合价"></el-option>
                            <el-option :value="2" label="不计入合价"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
              <el-table-column label="招标内容/需求" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData4.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired'
                  :class="{input_box:true,error_box:!scope.row.subitemName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="区域/位置" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData4.' + scope.$index + '.areaLocations'" :rules='form.rules.areaLocations'
                   :class="{input_box:true,error_box:!scope.row.areaLocations}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.areaLocations"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="制作工艺（工艺及材料描述详细）/事项内容要求描述" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData4.' + scope.$index + '.matterDesc'" :rules='form.rules.matterDesc'
                   :class="{input_box:true,error_box:!scope.row.matterDesc}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterDesc"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="数量/天数" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData4.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                   :class="{input_box:true,error_box:!scope.row.quantities}">
                    <el-input size="mini" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="单位" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData4.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                   :class="{input_box:true,error_box:!scope.row.unitName}">
                    <el-input size="mini" v-model="scope.row.unitName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="不含税单价（元）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData4.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'>
                    {{scope.row.unitAmountExclTax}}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="税率（%）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData4.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                   :class="{input_box:true,error_box:!scope.row.taxRatio}">
                    <el-select size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                      <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                    </el-select>
                    <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="含税单价（元）" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData4.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
                    :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                      <el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
                    </el-form-item>
                  </template>
              </el-table-column>
              <el-table-column label="税金（元）" width="140px">
                <template slot-scope="scope">
                    {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                </template>
              </el-table-column>
              <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                <template slot-scope="scope">
                  {{$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)}}
                </template>
              </el-table-column>
              <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                <template slot-scope="scope">
                    {{$root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities)}}
                </template>
              </el-table-column>
              <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}</span>
                    </template>
                </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
                <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="del(scope.$index, 4)"> 删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-else-if="parentCodeType == $root.wyfw_category">
          <div v-if="codeType == $root.wyfwba_category || codeType == $root.wyfwbj_category">
              <div v-if="operationEnable">
                <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData5"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
              </div>
              <el-table :max-height="maxHeight" key="tableData5" border :data="form.tableData5" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                <el-table-column label="序号" type="index" fixed="left" width="100px">
                    <template slot-scope="scope">
                        <el-form-item>
                            <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                        </el-form-item>
                    </template>
                </el-table-column>
                  <el-table-column label="报价类型" width="140px" v-if="false">
                      <template slot-scope="scope">
                          <el-select v-model="scope.row.quotationType"
                                     size="mini"
                                     class="minWidth">
                              <el-option :value="1" label="计入合价"></el-option>
                              <el-option :value="2" label="不计入合价"></el-option>
                          </el-select>
                      </template>
                  </el-table-column>
                <el-table-column label="岗位人员要求" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.matterName'" :rules='form.rules.matterName'
                    :class="{input_box:true,error_box:!scope.row.matterName}">
                      <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="客用品/清洁用品/岗位用品需求" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired'
                    :class="{input_box:true,error_box:!scope.row.matterRequired}">
                      <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                    :class="{input_box:true,error_box:!scope.row.unitName}">
                      <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.unitName"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="岗位时间" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.postTime'" :rules='form.rules.postTime'
                    :class="{input_box:true,error_box:!scope.row.postTime}">
                      <el-input size="mini" v-model="scope.row.postTime" @input="autoCompute(scope.row)"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="服务时长（月）" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.serviceTime'" :rules='form.rules.serviceTime'
                    :class="{input_box:true,error_box:!scope.row.serviceTime}">
                      <el-input size="mini" :oninput="$root.numberFilter_list_1" v-model="scope.row.serviceTime"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="岗位数量" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                    :class="{input_box:true,error_box:!scope.row.quantities}">
                      <el-input size="mini" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="实际岗位数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
                <el-table-column label="工时不含税单价（元/小时/岗）" width="140px">
                  <template slot-scope="scope">
                    {{scope.row.unitHourAmountExclTax}}
                  </template>
                </el-table-column>
                <el-table-column label="不含税单价（元）" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'>
                      {{scope.row.unitAmountExclTax}}
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率（%）" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                    :class="{input_box:true,error_box:!scope.row.taxRatio}">
                      <el-select size="mini" :disabled="scope.row.dealListStatus == 1" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                        <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                      </el-select>
                    <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input> -->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价（元）" width="140px">
                    <template slot-scope="scope">
                       	<el-form-item :prop="'tableData5.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
                         :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        	<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
						    </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="税金（元）" width="140px">
                  <template slot-scope="scope">
                      {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                  </template>
                </el-table-column>
                <el-table-column label="专业分类" width="140px">
                  <template slot-scope="scope">
                    {{categoryName}}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="del(scope.$index, 5)"> 删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>
          <div v-else>
              <div v-if="operationEnable">
                <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData6"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
              </div>
              <el-table :max-height="maxHeight" key="tableData6" border :data="form.tableData6" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                <el-table-column label="序号" type="index" fixed="left" width="100px">
                    <template slot-scope="scope">
                        <el-form-item>
                            <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                        </el-form-item>
                    </template>
                </el-table-column>
                  <el-table-column label="报价类型" width="140px" v-if="false">
                      <template slot-scope="scope">
                          <el-select v-model="scope.row.quotationType"
                                     size="mini"
                                     class="minWidth">
                              <el-option :value="1" label="计入合价"></el-option>
                              <el-option :value="2" label="不计入合价"></el-option>
                          </el-select>
                      </template>
                  </el-table-column>
                <el-table-column label="服务事项" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.matterName'" :rules='form.rules.matterName'
                    :class="{input_box:true,error_box:!scope.row.matterName}">
                      <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="服务内容要求描述" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired'
                    :class="{input_box:true,error_box:!scope.row.matterRequired}">
                      <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="服务频次" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.maintenanceFrequency'" :rules='form.rules.maintenanceFrequency'
                    :class="{input_box:true,error_box:!scope.row.maintenanceFrequency}">
                      <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.maintenanceFrequency"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="设备/服务参数描述" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.matterDesc'" :rules='form.rules.matterDesc'
                    :class="{input_box:true,error_box:!scope.row.matterDesc}">
                      <el-input size="mini" v-model="scope.row.matterDesc"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="维服务周期(月)" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.serviceTime'" :rules='form.rules.serviceTime'
                    :class="{input_box:true,error_box:!scope.row.serviceTime}">
                      <el-input size="mini" :oninput="$root.numberFilter_list_1" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.serviceTime"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                    :class="{input_box:true,error_box:!scope.row.quantities}">
                      <el-input size="mini" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
                <el-table-column label="单位" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                    :class="{input_box:true,error_box:!scope.row.unitName}">
                      <el-input size="mini" v-model="scope.row.unitName"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税单价（元）" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'>
                      {{scope.row.unitAmountExclTax}}
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率/服务费率（%）" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData6.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                    :class="{input_box:true,error_box:!scope.row.taxRatio}">
                      <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价（元/月）" width="140px">
                    <template slot-scope="scope">
                       	<el-form-item :prop="'tableData6.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
                         :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        	<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
						            </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column label="税金（元）" width="140px">
                  <template slot-scope="scope">
                      {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                  </template>
                </el-table-column>
                <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                  <template slot-scope="scope">
                    {{$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)}}
                  </template>
                </el-table-column>
                <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                  <template slot-scope="scope">
                      {{$root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities)}}
                  </template>
                </el-table-column>

                <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}</span>
                    </template>
                </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
                  <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" @click="del(scope.$index, 6)"> 删除</el-button>
                    </template>
                  </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-else-if="parentCodeType == $root.wywb_category">
            <div v-if="operationEnable">
              <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData7"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
            </div>
            <el-table :max-height="maxHeight" key="tableData7" border :data="form.tableData7" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
              <el-table-column label="序号" type="index" fixed="left" width="100px">
                  <template slot-scope="scope">
                      <el-form-item>
                          <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                      </el-form-item>
                  </template>
              </el-table-column>
                <el-table-column label="报价类型" width="140px" v-if="false">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.quotationType"
                                   size="mini"
                                   class="minWidth">
                            <el-option :value="1" label="计入合价"></el-option>
                            <el-option :value="2" label="不计入合价"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
              <el-table-column label="维保事项" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.matterName'" :rules='form.rules.matterName'
                  :class="{input_box:true,error_box:!scope.row.matterName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="维保内容要求描述" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired'
                  :class="{input_box:true,error_box:!scope.row.matterRequired}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="维保频次" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.maintenanceFrequency'" :rules='form.rules.maintenanceFrequency'
                  :class="{input_box:true,error_box:!scope.row.maintenanceFrequency}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.maintenanceFrequency"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="设备/服务参数描述" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.matterDesc'" :rules='form.rules.matterDesc'
                  :class="{input_box:true,error_box:!scope.row.matterDesc}">
                    <el-input size="mini" v-model="scope.row.matterDesc"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="维保周期(月)" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.serviceTime'" :rules='form.rules.serviceTime'
                  :class="{input_box:true,error_box:!scope.row.serviceTime}">
                    <el-input size="mini" :oninput="$root.numberFilter_list_1" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.serviceTime"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                  :class="{input_box:true,error_box:!scope.row.quantities}">
                    <el-input size="mini" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
              <el-table-column label="单位" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                  :class="{input_box:true,error_box:!scope.row.unitName}">
                    <el-input size="mini" v-model="scope.row.unitName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="不含税单价（元）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'
                  >
                    {{scope.row.unitAmountExclTax}}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="税率/服务费率（%）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                  :class="{input_box:true,error_box:!scope.row.taxRatio}">
                    <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="含税单价（元/月）" width="140px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData7.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
                    :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        <el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
                    </el-form-item>
                  </template>
              </el-table-column>
              <el-table-column label="税金（元）" width="140px">
                <template slot-scope="scope">
                    {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                </template>
              </el-table-column>
              <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                  <template slot-scope="scope">
                    {{$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)}}
                  </template>
              </el-table-column>
              <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                  <template slot-scope="scope">
                      {{$root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities)}}
                  </template>
              </el-table-column>

              <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}</span>
                  </template>
              </el-table-column>

              <el-table-column label="空调主机（冷量）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.conditionerHost'" :rules='form.rules.conditionerHost'
                  :class="{input_box:true,error_box:!scope.row.conditionerHost}">
                    <el-input size="mini" v-model="scope.row.conditionerHost"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="高压柜/低压柜（KVA）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData7.' + scope.$index + '.highLowVoltage'" :rules='form.rules.highLowVoltage'
                  :class="{input_box:true,error_box:!scope.row.highLowVoltage}">
                    <el-input size="mini" v-model="scope.row.highLowVoltage"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                  <template slot-scope="scope">
                    <el-button type="text"  size="mini" @click="del(scope.$index, 7)"> 删除</el-button>
                  </template>
                </el-table-column>
          </el-table>
        </div>
        <div v-else-if="parentCodeType == $root.sj_category">
            <div v-if="operationEnable">
              <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData8"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
            </div>
            <el-table :max-height="maxHeight" key="tableData8" border :data="form.tableData8" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
              <el-table-column label="序号" type="index" fixed="left" width="100px">
                  <template slot-scope="scope">
                      <el-form-item>
                          <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                      </el-form-item>
                  </template>
              </el-table-column>
                <el-table-column label="报价类型" width="140px" v-if="false">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.quotationType"
                                   size="mini"
                                   class="minWidth">
                            <el-option :value="1" label="计入合价"></el-option>
                            <el-option :value="2" label="不计入合价"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
              <el-table-column label="设计阶段/设计内容/设计范围/设计深度/设计系统" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData8.' + scope.$index + '.matterName'" :rules='form.rules.matterName'
                  :class="{input_box:true,error_box:!scope.row.matterName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData8.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                  :class="{input_box:true,error_box:!scope.row.quantities}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
              <el-table-column label="单位" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData8.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                  :class="{input_box:true,error_box:!scope.row.unitName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.unitName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="设计面积（㎡）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData8.' + scope.$index + '.designArea'" :rules='form.rules.designArea'
                  :class="{input_box:true,error_box:!scope.row.designArea}">
                    <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.designArea"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="不含税单价（元）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData8.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'
                  >
                    {{scope.row.unitAmountExclTax}}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="税率（%）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData8.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                  :class="{input_box:true,error_box:!scope.row.taxRatio}">
                    <el-select size="mini" :disabled="scope.row.dealListStatus == 1" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                        <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                      </el-select>
                  <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="含税单价（元）" width="140px">
                  <template slot-scope="scope">
						<el-form-item :prop="'tableData8.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
            :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        	<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
						</el-form-item>
                  </template>
              </el-table-column>
              <el-table-column label="税金（元）" width="140px">
                <template slot-scope="scope">
                    {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                </template>
              </el-table-column>
              <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                  <template slot-scope="scope">
                    {{$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)}}
                  </template>
              </el-table-column>
              <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                  <template slot-scope="scope">
                      {{$root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities)}}
                  </template>
              </el-table-column>

              <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}</span>
                    </template>
                </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="del(scope.$index, 8)"> 删除</el-button>
                  </template>
                </el-table-column>
          </el-table>
        </div>
        <div v-else-if="parentCodeType == $root.gw_category">
            <div v-if="operationEnable">
              <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData9"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
            </div>
            <el-table :max-height="maxHeight" key="tableData9" border :data="form.tableData9" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
              <el-table-column label="序号" type="index" fixed="left" width="100px">
                  <template slot-scope="scope">
                      <el-form-item>
                          <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                      </el-form-item>
                  </template>
              </el-table-column>
                <el-table-column label="报价类型" width="140px" v-if="false">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.quotationType"
                                   size="mini"
                                   class="minWidth">
                            <el-option :value="1" label="计入合价"></el-option>
                            <el-option :value="2" label="不计入合价"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
              <el-table-column label="顾问阶段/顾问服务内容/顾问范围/顾问系统/项目" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData9.' + scope.$index + '.matterName'" :rules='form.rules.matterName'
                  :class="{input_box:true,error_box:!scope.row.matterName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData9.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                  :class="{input_box:true,error_box:!scope.row.quantities}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
              <el-table-column label="单位" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData9.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                  :class="{input_box:true,error_box:!scope.row.unitName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.unitName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="不含税单价（元）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData9.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'>
                    {{scope.row.unitAmountExclTax}}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="税率（%）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData9.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                  :class="{input_box:true,error_box:!scope.row.taxRatio}">
                   <el-select size="mini" :disabled="scope.row.dealListStatus == 1" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                        <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                      </el-select>
                  <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="含税单价（元）/服务费率" width="140px">
                  <template slot-scope="scope">
                     	<el-form-item :prop="'tableData9.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
                       :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        	<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
						</el-form-item>
                  </template>
              </el-table-column>
              <el-table-column label="税金（元）" width="140px">
                <template slot-scope="scope">
                    {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                </template>
              </el-table-column>
              <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                <template slot-scope="scope">
                  {{$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)}}
                </template>
              </el-table-column>
              <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                <template slot-scope="scope">
                    {{$root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities)}}
                </template>
              </el-table-column>

              <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="del(scope.$index, 9)"> 删除</el-button>
                  </template>
                </el-table-column>
          </el-table>
        </div>
        <div v-else-if="parentCodeType == $root.xx_category">
            <div v-if="operationEnable">
              <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData10"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
            </div>
            <el-table :max-height="maxHeight" key="tableData10" border :data="form.tableData10" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
              <el-table-column label="序号" type="index" fixed="left" width="100px">
                  <template slot-scope="scope">
                      <el-form-item>
                          <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                      </el-form-item>
                  </template>
              </el-table-column>
                <el-table-column label="报价类型" width="140px" v-if="false">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.quotationType"
                                   size="mini"
                                   class="minWidth">
                            <el-option :value="1" label="计入合价"></el-option>
                            <el-option :value="2" label="不计入合价"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
              <el-table-column label="招标事项" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData10.' + scope.$index + '.matterName'" :rules='form.rules.matterName'
                  :class="{input_box:true,error_box:!scope.row.matterName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="招标需求内容描述/材质工艺等要求/服务内容" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData10.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired'
                  :class="{input_box:true,error_box:!scope.row.matterRequired}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="规格型号尺寸/服务要求" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData10.' + scope.$index + '.specificationServiceRequirements'" :rules='form.rules.specificationServiceRequirements'
                  :class="{input_box:true,error_box:!scope.row.specificationServiceRequirements}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.specificationServiceRequirements"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="投标品牌" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData10.' + scope.$index + '.brandName'" :rules='form.rules.brandName'
                  :class="{input_box:true,error_box:!scope.row.brandName}">
                    <el-input size="mini" v-model="scope.row.brandName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData10.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                  :class="{input_box:true,error_box:!scope.row.quantities}">
                    <el-input size="mini" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
              <el-table-column label="单位" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData10.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                  :class="{input_box:true,error_box:!scope.row.unitName}">
                    <el-input size="mini" v-model="scope.row.unitName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="不含税单价（元）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData10.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'>
                    {{scope.row.unitAmountExclTax}}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="税率（%）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData10.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                  :class="{input_box:true,error_box:!scope.row.taxRatio}">
                    <el-select size="mini" :disabled="scope.row.dealListStatus == 1" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                        <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                      </el-select>
                  <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="含税单价（元）" width="140px">
                  <template slot-scope="scope">
                     	<el-form-item :prop="'tableData10.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
                       :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        	<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
						</el-form-item>
                  </template>
              </el-table-column>
              <el-table-column label="税金（元）" width="140px">
                <template slot-scope="scope">
                    {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                </template>
              </el-table-column>
              <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                <template slot-scope="scope">
                  {{$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)}}
                </template>
              </el-table-column>
              <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                <template slot-scope="scope">
                    {{$root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities)}}
                </template>
              </el-table-column>

              <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      <span  v-if="scope.row.actualQuantities">{{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="del(scope.$index, 10)"> 删除</el-button>
                  </template>
                </el-table-column>
          </el-table>
        </div>
        <div v-else-if="parentCodeType == $root.xz_category">
            <div v-if="operationEnable">
              <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData11"><i class="iconfont iconjiahaoyou"></i> 添加</el-button>
            </div>
            <el-table :max-height="maxHeight" key="tableData11" border :data="form.tableData11" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
              <el-table-column label="序号" type="index" fixed="left" width="100px">
                  <template slot-scope="scope">
                      <el-form-item>
                          <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                      </el-form-item>
                  </template>
              </el-table-column>
                <el-table-column label="报价类型" width="140px" v-if="false">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.quotationType"
                                   size="mini"
                                   class="minWidth">
                            <el-option :value="1" label="计入合价"></el-option>
                            <el-option :value="2" label="不计入合价"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
              <el-table-column label="招标事项" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData11.' + scope.$index + '.matterName'" :rules='form.rules.matterName'
                  :class="{input_box:true,error_box:!scope.row.matterName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="招标需求内容描述/材质工艺等要求" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData11.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired'
                  :class="{input_box:true,error_box:!scope.row.matterRequired}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="规格型号尺寸" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData11.' + scope.$index + '.specificationServiceRequirements'" :rules='form.rules.specificationServiceRequirements'
                  :class="{input_box:true,error_box:!scope.row.specificationServiceRequirements}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.specificationServiceRequirements"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="投标品牌" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData11.' + scope.$index + '.brandName'" :rules='form.rules.brandName'
                  :class="{input_box:true,error_box:!scope.row.brandName}">
                    <el-input size="mini" v-model="scope.row.brandName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData11.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                  :class="{input_box:true,error_box:!scope.row.quantities}">
                    <el-input size="mini" :oninput="$root.numberFilter2" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
              <el-table-column label="单位" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData11.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                  :class="{input_box:true,error_box:!scope.row.unitName}">
                    <el-input size="mini" v-model="scope.row.unitName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="不含税单价（元）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData11.' + scope.$index + '.unitAmountExclTax'" :rules='form.rules.unitAmountExclTax'>
                    {{scope.row.unitAmountExclTax}}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="税率（%）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData11.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                  :class="{input_box:true,error_box:!scope.row.taxRatio}">
                   <el-select size="mini" :disabled="scope.row.dealListStatus == 1" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                        <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                      </el-select>
                  <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="含税单价（元）" width="140px">
                  <template slot-scope="scope">
                     	<el-form-item :prop="'tableData11.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
                       :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
                        	<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
						</el-form-item>
                  </template>
              </el-table-column>
              <el-table-column label="税金（元）" width="140px">
                <template slot-scope="scope">
                    {{$root.accMinus($root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities),$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                </template>
              </el-table-column>
              <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                  <template slot-scope="scope">
                    {{$root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)}}
                  </template>
              </el-table-column>
              <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                  <template slot-scope="scope">
                      {{$root.accMul($root.accMul(scope.row.unitAmountExclTax, $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1)), scope.row.quantities)}}
                  </template>
              </el-table-column>
              <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                  </template>
              </el-table-column>
              <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                  </template>
              </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="del(scope.$index, 11)"> 删除</el-button>
                  </template>
              </el-table-column>
          </el-table>
        </div>
        <div v-else>
            <div v-if="operationEnable">
              <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData12"><i class="iconfont iconjiahaoyou"></i> 新增</el-button>
            </div>
            <el-table :max-height="maxHeight" key="tableData12" border :data="form.tableData12" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
              <el-table-column label="序号" type="index" fixed="left" width="100px">
                  <template slot-scope="scope">
                      <el-form-item>
                          <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                      </el-form-item>
                  </template>
              </el-table-column>
                <el-table-column label="报价类型" width="140px" v-if="false">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.quotationType"
                                   size="mini"
                                   class="minWidth">
                            <el-option :value="1" label="计入合价"></el-option>
                            <el-option :value="2" label="不计入合价"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
              <el-table-column label="招标事项" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData12.' + scope.$index + '.matterName'" :rules='form.rules.matterName'
                  :class="{input_box:true,error_box:!scope.row.matterName}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="招标需求内容描述/材质工艺等要求/品牌规格型号" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData12.' + scope.$index + '.matterRequired'" :rules='form.rules.matterRequired'
                  :class="{input_box:true,error_box:!scope.row.matterRequired}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-model="scope.row.matterRequired"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="140px">
                <template slot-scope="scope">
                   <el-form-item :prop="'tableData12.' + scope.$index + '.quantities'" :rules='form.rules.quantities'
                   :class="{input_box:true,error_box:!scope.row.quantities}">
                    <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" @keyup.native="keyupCallback(scope.row)" v-model="scope.row.quantities" @input="autoCompute(scope.row)"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="this.pageType == 'orderAdd' && false"></el-table-column>
              <el-table-column label="单位" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData12.' + scope.$index + '.unitName'" :rules='form.rules.unitName'
                  :class="{input_box:true,error_box:!scope.row.unitName}">
                    <el-input size="mini" v-model="scope.row.unitName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax">
				        <template slot-scope="scope">
                  <span class="paddingL15">{{scope.row.unitAmountExclTax}}</span>
                </template>
              </el-table-column>
              <el-table-column label="税率（%）" width="140px">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData12.' + scope.$index + '.taxRatio'" :rules='form.rules.taxRatio'
                  :class="{input_box:true,error_box:!scope.row.taxRatio}">
                    <el-select size="mini" :disabled="scope.row.dealListStatus == 1" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                        <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                      </el-select>
                  <!-- <el-input size="mini" :oninput="$root.numberFilter" v-model="scope.row.taxRatio" @input="autoCompute(scope.row)"></el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                <template slot-scope="scope">
					<el-form-item :prop="'tableData12.' + scope.$index + '.unitAmountWithTax'" :rules='form.rules.unitAmountWithTax'
          :class="{input_box:true,error_box:!scope.row.unitAmountWithTax}">
						<el-input size="mini" :oninput="$root.numberFilter4" v-model="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)"></el-input>
					</el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="税金（元）" prop="taxRatioAmount">
                <template slot-scope="scope">
                    {{scope.row.taxAmount}}
                </template>
              </el-table-column>
              <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                 <template slot-scope="scope">
                     {{scope.row.amountExclTax}}
                  </template>
              </el-table-column>
              <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                  <template slot-scope="scope">
                      {{scope.row.amountWithTax}}
                  </template>
              </el-table-column>
              <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                  </template>
              </el-table-column>
              <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="this.pageType == 'orderAdd' && false">
                  <template slot-scope="scope">
                      {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                  </template>
              </el-table-column>
              <el-table-column label="专业分类" width="140px">
                <template slot-scope="scope">
                  {{categoryName}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="del(scope.$index, 12)"> 删除</el-button>
                  </template>
                </el-table-column>
          </el-table>
        </div>
      </el-form>
    </div>
</template>

<script>

import Vue from 'vue'
export default Vue.component('inventory',{
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: ['code', 'parentCode', 'page', 'readonly','maxHeight','orderStatus'],
    computed: {
      operationEnable(){
        return !this.readonly;
      }
    },
   watch: {
      code(val){
        this.codeType = val;
      },
      page(val){
        this.pageType = val;
      },
      parentCode(val){
        this.parentCodeType = val;
      },
    },
    data() {
        return {
            taxList: [],
            categoryId:'',
            categoryName: '',
            codeType: '',
            parentCodeType: '',
            pageType: '',

            form: {
                rules: {},
                tableData1: [],
                tableData2: [],
                tableData3: [],
                tableData4: [],
                tableData5: [],
                tableData6: [],
                tableData7: [],
                tableData8: [],
                tableData9: [],
                tableData10: [],
                tableData11: [],
                tableData12: [],
            }
        }
    },
    //方法集合
    methods: {
        autoCompute(row) {
          if (this.pageType == "buyDemand") {
              return;
          }
          if (!row.unitAmountWithTax || !row.taxRatio) {
              row.unitAmountExclTax = '';
              row.amountExclTax = '';
              row.amountWithTax = '';
              return;
          }
          let ratio = row.taxRatio;
          if (row.taxRatio >= 1) {
              ratio = this.$root.accDiv(parseFloat(row.taxRatio), 100);
          }
          let unitAmountExclTaxOld = parseFloat((parseFloat(row.unitAmountWithTax) / (1 + parseFloat(ratio))))
          row.unitAmountExclTax = unitAmountExclTaxOld.toFixed(2);
          if(row.postTime){
              row.unitHourAmountExclTax = (unitAmountExclTaxOld / parseFloat(row.postTime) / 30).toFixed(2);
          } else {
              row.unitHourAmountExclTax = '';
          }
          if (!row.quantities) {
              row.amountExclTax = '';
              row.amountWithTax = '';
              return;
          }
          let tempDayAmount = 1;
          if (row.dayAmount) {
              tempDayAmount = parseFloat(row.dayAmount);
          }
          let tempServiceTime = 1;
          if (row.serviceTime) {
              tempServiceTime = parseFloat(row.serviceTime);
          }
          let amountWithTaxOld = parseFloat(
              parseFloat(row.unitAmountWithTax) *
              parseFloat(row.quantities) *
              parseFloat(tempDayAmount) *
              parseFloat(tempServiceTime)
          );
          row.amountWithTax = amountWithTaxOld.toFixed(2);
          let amountExclTaxOld = this.$root.accDiv(amountWithTaxOld, 1 + parseFloat(ratio));
          row.amountExclTax = this.$root.accDiv(amountWithTaxOld, 1 + parseFloat(ratio));
          row.taxAmount = (amountExclTaxOld * ratio).toFixed(2)
          // 订单金额更新
          if(this.pageType == "orderAdd"){
            this.$emit('callback')
          }
      },
      keyupCallback(row){
        if(row.quantities.replace){
          row.quantities = row.quantities.replace(/[^\d.]/g,'');
        }
      },
      validate(){
        this.$refs['form'].validate((valid,model)=>{
            console.log(valid);
            console.log(model);
        })
      },
      resetForm(){
          this.$refs['form'].resetFields();
      },
      getData(){
        if(this.parentCodeType == this.$root.gc_category){
          return this.form.tableData1;
          // return {
          //   wflowFormListList: this.form.tableData1,
          //   // wflowFormListList2: this.form.tableData2
          // }
        }else if(this.parentCodeType == this.$root.wzsb_category){
          return this.form.tableData3;
          // return {
          //   wflowFormListList: this.form.tableData3,
          // }
        }else if(this.parentCodeType == this.$root.yxtg_category){
          return this.form.tableData4;
          // return {
          //   wflowFormListList: this.form.tableData4,
          // }
        }else if(this.parentCodeType == this.$root.wyfw_category){
          if(this.codeType == this.$root.wyfwba_category || this.codeType == this.$root.wyfwbj_category){
            return this.form.tableData5;
            // return {
            //   wflowFormListList: this.form.tableData5,
            // }
          }else {
            return this.form.tableData6;
            // return {
            //   wflowFormListList: this.form.tableData6,
            // }
          }
        }else if(this.parentCodeType == this.$root.wywb_category){
          return this.form.tableData7;
          // return {
          //   wflowFormListList: this.form.tableData7,
          // }
        }else if(this.parentCodeType == this.$root.sj_category){
          return this.form.tableData8;
          // return {
          //   wflowFormListList: this.form.tableData8,
          // }
        }else if(this.parentCodeType == this.$root.gw_category){
          return this.form.tableData9;
          // return {
          //   wflowFormListList: this.form.tableData9,
          // }
        }else if(this.parentCodeType == this.$root.xx_category){
          return this.form.tableData10;
          // return {
          //   wflowFormListList: this.form.tableData10,
          // }
        }else if(this.parentCodeType == this.$root.xz_category){
          return this.form.tableData11;
          // return {
          //   wflowFormListList: this.form.tableData11,
          // }
        }else {
          return this.form.tableData12;
          // return {
          //   wflowFormListList: this.form.tableData12,
          // }
        }
      },
        setData(list1, obj){
            list1 = list1 || [];
            // console.log("priceTableInput", obj)
            if (obj) {
			      this.parentCodeType = obj.parentCategoryCode;
              this.codeType = obj.categoryCode;
              this.categoryName = obj.categoryName;
              this.categoryId = obj.categoryId;
          }
            
          this.$root.getHttp('/v1/sysDict/public/getDictListByDictType?dictType=' + 'flow_form_tax_config', (res) => {
            this.taxList = res.data.data
          });
          list1.forEach(item => {
                if(!item.segmentsNumber){
                    item.segmentsNumber = 1;
                }
                item.categoryId = this.categoryId

                // 清单数量、金额小数点控制
                if (item.quantities && item.quantities != 0) item.quantities = parseFloat(item.quantities).toFixed(3)
                if (item.unitAmountExclTax && item.unitAmountExclTax != 0) item.unitAmountExclTax = parseFloat(item.unitAmountExclTax).toFixed(2)
                if (item.amountExclTax && item.amountExclTax != 0) item.amountExclTax = parseFloat(item.amountExclTax).toFixed(2)
                if (item.amountWithTax && item.amountWithTax != 0) item.amountWithTax = parseFloat(item.amountWithTax).toFixed(2)
            });

            if(this.parentCodeType == this.$root.gc_category){
                this.form.tableData1 = list1;
                // this.form.tableData2 = list2;
            }else if(this.parentCodeType == this.$root.wzsb_category){
                this.form.tableData3 = list1;
            }else if(this.parentCodeType == this.$root.yxtg_category){
                this.form.tableData4 = list1;
            }else if(this.parentCodeType == this.$root.wyfw_category){
                if(this.codeType == this.$root.wyfwba_category || this.codeType == this.$root.wyfwbj_category){
                    this.form.tableData5 = list1;
                }else {
                    this.form.tableData6 = list1;
                }
            }else if(this.parentCodeType == this.$root.wywb_category){
                this.form.tableData7 = list1;
            }else if(this.parentCodeType == this.$root.sj_category){
                this.form.tableData8 = list1;
            }else if(this.parentCodeType == this.$root.gw_category){
                this.form.tableData9 = list1;
            }else if(this.parentCodeType == this.$root.xx_category){
                this.form.tableData10 = list1;
            }else if(this.parentCodeType == this.$root.xz_category){
                this.form.tableData11 = list1;
            }else {
                this.form.tableData12 = list1;
            }
        },
        submitFormFnc(formName){
          let that = this;
          var f = function (){
              const p = new Promise((resolve, reject) => {
                  let form = that.$refs[formName];
                  if(Array.isArray(that.$refs[formName])){
                      form = that.$refs[formName][0]
                  }
                  form.validate((valid) => {
                      if(valid){
                          resolve(true);
                      } else {
                          reject('请正确填写清单必填信息！');
                      }
                  });
              });
              return p;
          }
          return f;
      },
      submitFormPromise(formName){
          return this.submitFormFnc(formName)();
      },
      formateRequiredRules(attrs){
        let rules = {};
        let numberAttrs = ['constructArea', 'serviceRenovationArea', 'quantities', 'postPerConstructArea', 'designArea', 'supplyUnitPrice', 'installUnitPrice',
        'unitAmountExclTax', 'unitAmountWithTax', 'amountExclTax', 'amountWithTax', 'unitHourAmountExclTax', 'monthlyAmountExclTax', 'monthlyAmountWithTax', 'yearlyAmountExclTax', 'yearlyAmountWithTax', 'hourlyUnitPrice', 'unitPricePerSquare', 'taxRatio','serviceTime'];

        attrs.forEach((name, index) => {
          rules[name] = [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }];
          if(numberAttrs.indexOf(name) != -1){
            // rules[name].push(
            // {
            //     type: 'number',
            //     message: '必须为数字值',
            //     trigger: 'blur'
            // });
            if (name == 'quantities') {
              rules[name].push(
                {
                    pattern: /(^[0-9]+$)|(^[0-9]+[\.]{1}[0-9]{1,3}$)/g,
                    message: '必须为有效数值',
                    trigger: 'blur'
                });
            } else {
              rules[name].push(
                {
                    pattern: /(^[0-9]+$)|(^[0-9]+[\.]{1}[0-9]{1,2}$)/g,
                    message: '必须为有效数值',
                    trigger: 'blur'
                });
            }
          }
        });
        return rules;
      },
      del(index, type){
        this.form['tableData'+type].splice(index,1);
      },
      addData1(editable=true){
        if(!this.categoryName){
          this.$alert('请先编制价格库清单，确定招标类别！',{
              type: 'warning'
          });
          return;
        }
        var item = {
            quotationType:1,
            categoryId:this.categoryId,
            categoryName:this.categoryName,
            subitemName: '',//分部分项名称
            matterName: '',//工程项名称
            matterRequired: '', //工作/工艺内容描述/规格型号参数
            recommendBrand: '',//投标推荐品牌
            brandName: '', //投标品牌
            constructArea: '',//建筑面积（㎡）
            serviceRenovationArea: '', //改造面积（㎡）
            unitName: '', //单位
            quantities: '', //数量
            supplyUnitPrice: '', //供应单价（元）
            installUnitPrice: '', //安装单价（元）
            unitAmountExclTax: '', //不含税综合单价（元）
            taxRatio: '', //税率（%）
            unitAmountWithTax: '',//含税综合单价（元）
            amountExclTax: '',//不含税合价（元）
            amountWithTax: '',//含税合价（元）
            remarks: '',//备注
            editable: editable,
        };
        this.form.tableData1.push(item);
      },
      addData2(editable=true){
        if(!this.categoryName){
          this.$alert('请先编制价格库清单，确定招标类别！',{
              type: 'warning'
          });
          return;
        }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              subitemName: '',//分部分项名称
              matterName: '',//工程项名称
              matterRequired: '', //工作/工艺内容描述/规格型号参数
              recommendBrand: '',//投标推荐品牌
              brandName: '', //投标品牌
              constructArea: '',//建筑面积（㎡）
              serviceRenovationArea: '', //改造面积（㎡）
              unitName: '', //单位
              quantities: '', //数量
              supplyUnitPrice: '', //供应单价（元）
              installUnitPrice: '', //安装单价（元）
              unitAmountExclTax: '', //不含税综合单价（元）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税综合单价（元）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              remarks: '',//备注
              listPurpose: '2',
              editable: editable,
          };
          this.form.tableData2.push(item);
      },
      addData3(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//招标事项
              matterRequired: '', //招标需求内容描述/材质工艺等要求/规格型号
              brandName: '', //品牌
              quantities: '', //数量
              unitName: '', //单位
              unitAmountExclTax: '', //不含税单价（元）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税单价（元）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              remarks: '',//备注
              editable: editable,
          };
          this.form.tableData3.push(item);
      },
      addData4(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//合同编号
              matterRequired: '', //招标内容/需求
              areaLocations: '', //区域/位置
              // attachements: [], //示意图片
              matterDesc: '',//制作工艺（工艺及材料描述详细）/事项内容要求描述
              brandName: '', //品牌
              quantities: '', //数量/天数
              unitName: '', //单位
              unitAmountExclTax: '', //不含税单价（元）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税单价（元）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              remarks: '',//备注
              editable: editable,
          };
          this.form.tableData4.push(item);
      },
      addData5(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//岗位人员要求
              matterRequired: '', //客用品/清洁用品/岗位用品需求
              // constructArea: '',//建筑面积（㎡）
              unitName: '', //单位
              quantities: '', //岗位数量
              postTime: '',//岗位时间
              serviceTime:'',
              unitHourAmountExclTax: '', //工时不含税单价（元/小时/岗）
              unitAmountExclTax: '', //不含税单价（元/月/岗）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税单价（元/月/岗）
              monthlyAmountExclTax: '',//月度不含税合价（元/月）
              monthlyAmountWithTax: '', //月度含税合价（元/月）
              yearlyAmountExclTax: '',//年度不含税合价（元/年）
              yearlyAmountWithTax: '',//年度含税合价（元/年）
              remarks: '',//备注
              // hourlyUnitPrice: '',//工时单价（元/小时/岗）
              // postPerConstructArea: '', //岗位均建筑面积（㎡/岗）
              editable: editable,
          };
          this.form.tableData5.push(item);
      },
      addData6(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//维保事项
              matterRequired: '', //维保内容要求描述
              maintenanceFrequency: '',//维保频次
              matterDesc: '', //设备/服务参数描述
              quantities: '', //数量
              unitName: '', //单位
              unitAmountExclTax: '', //不含税单价（元/月）
              taxRatio: '', //税率/服务费率（%）
              unitAmountWithTax: '',//含税单价（元/月）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              conditionerHost: '',//空调主机（冷量）
              highLowVoltage: '', //高压柜/低压柜（KVA）

              remarks: '',//备注
              hourlyUnitPrice: '',//工时单价（元/小时/岗）
              postPerConstructArea: '', //岗位均建筑面积（㎡/岗）
              constructArea: '',//建筑面积
              unitPricePerSquare: '',//平米单价（元/平米）
              editable: editable,
          };
          this.form.tableData6.push(item);
      },
      addData7(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//维保事项
              matterRequired: '', //维保内容要求描述
              maintenanceFrequency: '',//维保频次
              matterDesc: '', //设备/服务参数描述
              quantities: '', //数量
              unitName: '', //单位
              unitAmountExclTax: '', //不含税单价（元/月）
              taxRatio: '', //税率/服务费率（%）
              unitAmountWithTax: '',//含税单价（元/月）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              conditionerHost: '',//空调主机（冷量）
              highLowVoltage: '', //高压柜/低压柜（KVA）

              remarks: '',//备注
              // hourlyUnitPrice: '',//工时单价（元/小时/岗）
              // postPerConstructArea: '', //岗位均建筑面积（㎡/岗）
              constructArea: '',//建筑面积
              unitPricePerSquare: '',//平米单价（元/平米）
              editable: editable,
          };
          this.form.tableData7.push(item);
      },
      addData8(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//设计阶段/设计内容/设计范围/设计深度/设计系统
              quantities: '', //数量
              unitName: '', //单位
              constructArea: '',//建筑面积
              designArea: '',//设计面积
              unitAmountExclTax: '', //不含税单价（元）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税单价（元）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              remarks: '',//备注
              editable: editable,
          };
          this.form.tableData8.push(item);
      },
      addData9(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryName:this.categoryName,
              matterName: '',//顾问阶段/顾问服务内容/顾问范围/顾问系统/项目
              quantities: '', //数量
              unitName: '', //单位
              serviceFeeRatio: '', //服务费率
              unitAmountExclTax: '', //不含税单价（元）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税单价（元）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              editable: editable,
          };
          this.form.tableData9.push(item);
      },
      addData10(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//招标事项
              matterRequired: '',//招标需求内容描述/材质工艺等要求/服务内容
              quantities: '', //数量
              brandName: '',//品牌
              specificationServiceRequirements: '', //规格型号尺寸/服务要求
              unitName: '', //单位
              unitAmountExclTax: '', //不含税单价（元）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税单价（元）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              remarks: '',//备注
              editable: editable,
          };
          this.form.tableData10.push(item);
      },
      addData11(editable=true){
          if(!this.categoryName){
            this.$alert('请先编制价格库清单，确定招标类别！',{
                type: 'warning'
            });
            return;
          }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//招标事项
              matterRequired: '',//招标需求内容描述/材质工艺等要求
              quantities: '', //数量
              brandName: '',//品牌
              specificationServiceRequirements: '', //规格型号尺寸
              unitName: '', //单位
              unitAmountExclTax: '', //不含税单价（元）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税单价（元）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              remarks: '',//备注
              editable: editable,
          };
          this.form.tableData11.push(item);
      },
      addData12(editable=true){
          // if(!this.categoryName){
          //   this.$alert('请先选择招标类型',{
          //       type: 'warning'
          //   });
          //   return;
          // }
          var item = {
              quotationType:1,
              categoryId:this.categoryId,
              categoryName:this.categoryName,
              matterName: '',//招标事项
              matterRequired: '',//招标需求内容描述/材质工艺等要求/品牌规格型号
              quantities: '', //数量
              unitName: '', //单位
              unitAmountExclTax: '', //不含税单价（元/月）
              taxRatio: '', //税率（%）
              unitAmountWithTax: '',//含税单价（元/月）
              amountExclTax: '',//不含税合价（元）
              amountWithTax: '',//含税合价（元）
              remarks: '',//备注
              editable: editable,
          };
          this.form.tableData12.push(item);
      },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      // debugger;
      this.quotationMethod = this.quotationFlag;
      this.taxRatioMethod = this.taxRatioFlag;
      this.pageType = this.page;
      this.codeType = this.code;
      this.parentCodeType = this.parentCode;
      this.segmentsNumber = this.segments;

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.form.rules = this.formateRequiredRules(['subitemName', 'matterName', 'matterRequired', 'recommendBrand', 'brandName', 'constructArea', 'serviceRenovationArea', 'unitName', 'quantities', 'areaLocations', 'matterDesc', 'postTime', 'serviceTime', 'postPerConstructArea', 'maintenanceFrequency', 'conditionerHost', 'highLowVoltage', 'designArea', 'specificationServiceRequirements'])

      if(this.pageType == 'tenderEdit'){
        this.form.rules = this.formateRequiredRules(['subitemName', 'matterName', 'matterRequired', 'recommendBrand', 'brandName', 'constructArea', 'serviceRenovationArea', 'unitName', 'quantities', 'remarks', 'areaLocations', 'matterDesc', 'postTime', 'serviceTime', 'postPerConstructArea', 'maintenanceFrequency', 'conditionerHost', 'highLowVoltage', 'designArea', 'specificationServiceRequirements','remarks', 'supplyUnitPrice', 'installUnitPrice', 'unitAmountExclTax', 'unitAmountWithTax', 'amountExclTax', 'amountWithTax', 'unitHourAmountExclTax', 'monthlyAmountExclTax', 'monthlyAmountWithTax', 'yearlyAmountExclTax', 'yearlyAmountWithTax', 'hourlyUnitPrice', 'unitPricePerSquare']);
      } else if (this.pageType == 'orderAdd') {
        this.form.rules = this.formateRequiredRules(['subitemName', 'matterName', 'matterRequired', 'recommendBrand', 'brandName', 'constructArea', 'serviceRenovationArea', 'unitName', 'quantities', 'remarks', 'areaLocations', 'matterDesc', 'postTime', 'postPerConstructArea', 'maintenanceFrequency', 'conditionerHost', 'highLowVoltage', 'designArea', 'specificationServiceRequirements','remarks', 'supplyUnitPrice', 'installUnitPrice', 'unitAmountExclTax', 'unitAmountWithTax', 'amountExclTax', 'amountWithTax', 'unitHourAmountExclTax', 'monthlyAmountExclTax', 'monthlyAmountWithTax', 'yearlyAmountExclTax', 'yearlyAmountWithTax', 'hourlyUnitPrice', 'unitPricePerSquare', 'taxRatio']);
      }
      if (!this.form.rules['taxRatio']){
          this.form.rules['taxRatio'] = []
      }
      this.form.rules['taxRatio'].push({
          validator: 'regexp',
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '正数,最多2位小数', trigger: 'blur'
      })
    },
})
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
@import '../../../assets/_var.scss';
.inventory /deep/{
  margin-top: -15px;
  .el-input__inner {
      // border: 1px solid #C4C4C4!important;
      border-radius: 0!important;
      padding: 0;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-form-item__content{
    line-height: 28px;
  }
  .el-table td .cell{
    padding: 0;
  }
  .el-form-item.is-error .el-input__inner {
    border-color: #f56c6c!important;
  }
  // .input_box {
  //   position: absolute;
  //   left: -1px;
  //   right: -1px;
  //   top: -1px;
  //   bottom: -1px;
  // }

.el-table__body tr:last-child .input_box.error_box {
  // bottom: 1px;
}

.input_box.error_box {
  border: 1px solid #dd2727;
}
  .text-button.el-button {
      font-size: 16px;
      text-align: left;
      color: #333333;
      line-height: 21px;
      background: white;
      border: none;
  }
  .el-table--mini th, .el-table--mini td {
    padding: 0px;
  }


}
.isRed /deep/ {
    color: red;
    font-weight: 700;
    .el-input__inner {
        color: red;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/components/priceTableInput.vue